type ResponseStamp = {
  businessId: string
  sequence: number
}

type StampedState = Record<string, unknown> & {
  __plummeMutationResponse?: ResponseStamp
}

const RESPONSE_STAMP = '__plummeMutationResponse'

const createMutationResponseOrder = () => {
  let nextSequence = 0
  const latestAppliedByBusiness = new Map<string, number>()

  const issue = (businessId: unknown): ResponseStamp => ({
    businessId: String(businessId || ''),
    sequence: ++nextSequence,
  })

  const stamp = <T extends Record<string, any>>(payload: T, responseStamp?: ResponseStamp | null): T => {
    if (!responseStamp || !payload?.state || typeof payload.state !== 'object') return payload
    Object.defineProperty(payload.state, RESPONSE_STAMP, {
      value: responseStamp,
      configurable: true,
      enumerable: false,
    })
    return payload
  }

  const accept = (state: unknown, activeBusinessId: unknown) => {
    const responseStamp = (state as StampedState | null)?.[RESPONSE_STAMP]
    if (!responseStamp) return { accepted: true, reason: 'unstamped' as const }
    const businessId = String(activeBusinessId || '')
    if (!businessId || responseStamp.businessId !== businessId) {
      return { accepted: false, reason: 'business-changed' as const }
    }
    const latestApplied = latestAppliedByBusiness.get(businessId) || 0
    if (responseStamp.sequence < latestApplied) {
      return { accepted: false, reason: 'older-response' as const }
    }
    latestAppliedByBusiness.set(businessId, responseStamp.sequence)
    return { accepted: true, reason: 'current-response' as const }
  }

  return { issue, stamp, accept }
}

const mutationResponseOrderApi = { createMutationResponseOrder }
window.PlummeMutationResponseOrder = mutationResponseOrderApi
